import { useState } from 'react';
import {
  AckBadge,
  AckMatchBadge,
  OpsEmpty,
  OpsError,
  OpsLoading,
  OpsPagination,
  OpsTable,
  Th,
  formatOpsDate,
} from '@/components/OpsTable';
import { ApiCallError } from '@/lib/api';
import { useOpsAcknowledgements } from '@/hooks/useOpsDashboard';

export function Acknowledgements() {
  const [offset, setOffset] = useState(0);
  const { data, isLoading, error } = useOpsAcknowledgements(offset);
  const items = data?.items ?? [];
  const pagination = data?.pagination;

  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Acknowledgements</h1>

      {error && (
        <OpsError
          message={error instanceof ApiCallError ? error.message : 'Could not load acknowledgements.'}
        />
      )}

      {isLoading ? (
        <OpsLoading />
      ) : items.length === 0 ? (
        <OpsEmpty description="No acknowledgements yet." />
      ) : (
        <>
          <OpsTable>
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <Th>Type</Th>
                <Th>Match</Th>
                <Th>Status</Th>
                <Th>Bundle</Th>
                <Th>Error</Th>
                <Th>Created</Th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-card-dark">
              {items.map((item) => (
                <tr key={item.id} className="transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-800">
                  <td className="whitespace-nowrap px-3 py-4 text-sm first:pl-4 sm:first:pl-6">
                    <AckBadge ack={item} />
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm first:pl-4 sm:first:pl-6">
                    <AckMatchBadge status={item.matchStatus} />
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 dark:text-gray-400">
                    {item.status}
                  </td>
                  <td className="max-w-xs truncate px-3 py-4 text-sm text-gray-500 dark:text-gray-400">
                    {item.bundleId ?? '—'}
                  </td>
                  <td className="max-w-sm truncate px-3 py-4 text-sm text-gray-500 dark:text-gray-400">
                    {item.errorMessage ?? item.errorCode ?? '—'}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 dark:text-gray-400">
                    {formatOpsDate(item.createdAt)}
                  </td>
                </tr>
              ))}
            </tbody>
          </OpsTable>
          {pagination && (
            <OpsPagination
              total={pagination.total}
              limit={pagination.limit}
              offset={pagination.offset}
              onOffsetChange={setOffset}
            />
          )}
        </>
      )}
    </div>
  );
}
